import { render, staticRenderFns } from "./transport-situation.vue?vue&type=template&id=bc46aaf6"
import script from "./transport-situation.vue?vue&type=script&lang=js"
export * from "./transport-situation.vue?vue&type=script&lang=js"
import style0 from "./transport-situation.vue?vue&type=style&index=0&id=bc46aaf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports